export function remCal (pixels) {
  const rem = pixels / 16 + 'rem'
  return rem
}
